import axios from "axios";
import { getToken } from "../../jwt";

// Determine base URL based on environment
const getBaseURL = () => {
  if (import.meta.env.DEV) {
    // En desarrollo, usar el proxy de Vite
    return "/api/dtes/";
  } else {
    // En producción, usar la URL directa
    return "https://api-pruebas.botblaze.tech/"; // cambiar a https://api.botblaze.tech/ en producción
  }
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000, // 30 segundos de timeout
  headers: {
    'Content-Type': 'application/json',
  }
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor para manejo de errores
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
